import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { Payroll } from '../models/salaries/payroll';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { CACHE_KEYS } from '../contants/CACHE_KEYS';
import { RequestResult } from '../models/common/requestResult';
import { PageOption } from '../models/common/pageOption';
import { PayrollFilter } from '../models/salaries/payroll.filter';
import { PageOptionResult } from '../models/common/pageOptionResult';
import { of } from '../../../node_modules/rxjs/observable/of';

@Injectable()
export class PayrollService {
	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getExistingPayroll(id: number): Observable<Payroll> {
		return this._http.get<Payroll>(`${this.origin}/api/payrolls/${id}`)
			.pipe(
				tap(x => this.log(`getExistingPayroll: id=${id}`)),
				catchError(this._logService.handleError<Payroll>('getExistingPayroll'))
			);
    }
    
    initializePayroll(dateFrom: string, dateTo: string, type: string): Observable<RequestResult<Payroll>> {
		return this._http.get<RequestResult<Payroll>>(`${this.origin}/api/payrolls/initial?from=${dateFrom}&to=${dateTo}&type=${type}`)
			.pipe(
				tap(x => this.log(`getPayroll: from=${dateFrom}, to=${dateTo}, type=${type}`)),
				catchError(this._logService.handleError<RequestResult<Payroll>>('getPayroll'))
			);
	}

    getPayrollsList(filter: PageOption<PayrollFilter>): Observable<PageOptionResult<Payroll>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<Payroll>>(`${this.origin}/api/payrolls${param}`)
			.pipe(
				tap(x => this.log(`getPayrollsList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<Payroll>>('getPayrollsList'))
			);
	}

	getPayrollDatesDropdownList(): Observable<string[]> {
		let value = this._cacheService.get(CACHE_KEYS.payrollDateSelection)
		if (value != null) {
			return of(value);
		}

		return this._http.get<string[]>(`${this.origin}/api/menus/payrolls/dates`)
			.pipe(
				tap(x => {
					this.log(`getPayrollDatesDropdownList`);
					if(x != undefined){
						this._cacheService.add(CACHE_KEYS.payrollDateSelection, x, 120)
					}
				}),
				catchError(this._logService.handleError<string[]>('getPayrollDatesDropdownList'))
			);
	}

	getExportUrl(filter: PayrollFilter) {
		var queryString = this._common.objectToQueryParam(filter);
		return this._http.get(`${this.origin}/api/payrolls/reports${queryString}`, {responseType: 'arraybuffer'});
    }

	addPayroll(data: Payroll): Observable<RequestResult<Payroll>> {
		this._cacheService.remove(CACHE_KEYS.payrollTypeSelection); //remove custom cache
		return this._http.post<RequestResult<Payroll>>(`${this.origin}/api/payrolls`, JSON.stringify(data))
			.pipe(
				tap(x => {
					this.log(`addPayroll: id=${data.id}`);
					this._cacheService.remove(CACHE_KEYS.payrollDateSelection);
				}),
				catchError(this._logService.handleError<RequestResult<Payroll>>('addPayroll'))
			);
	}

	updatePayroll(data: Payroll): Observable<RequestResult<Payroll>> {
		this._cacheService.remove(CACHE_KEYS.payrollTypeSelection); //remove custom cache
		return this._http.put<RequestResult<Payroll>>(`${this.origin}/api/payrolls/${data.id}`, JSON.stringify(data))
			.pipe(
				tap(x => this.log(`updatePayroll: id=${data.id}`)),
				catchError(this._logService.handleError<RequestResult<Payroll>>('updatePayroll'))
			);
	}

	private log(message: string) {
		this._messagesService.add('PayrollService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/payroll.service.ts